import { gql } from "generated-graphql";

export const CREDENTIALS_FOR_STAFF_QUERY = gql(`
  query CredentialsForStaff($search: String, $page: Int, $pageSize: Int, $sort: [SortModel!]) {
    credentialsForStaff(search: $search, page: $page, pageSize: $pageSize, sort: $sort) {
      items {
        id
        name
        username
        isEncampOwned
        portalName
        verificationStatus
        lastVerificationCheckAt
        currentlyInUse
        tenantCount
        facilityCount
      }
      count
    }
  }
`);

export const CREDENTIAL_FOR_STAFF_QUERY = gql(`
  query CredentialForStaff($id: ID!) {
    credentialForStaff(id: $id) {
      id
      name
      username
      email
      isEncampOwned
      kind
      portalId
      portalName
      password
      securityQuestions {
        question
        answer
      }
      verificationStatus
      lastVerificationCheckAt
      currentlyInUse
      tenantCount
      facilityCount
      tenantName
      tenants {
        id
        name
        facilities {
          id
          name
          streetAddress1
          city
          state
          zip
          lepcName
        }
      }
    }
  }
`);

export const UPSERT_CREDENTIAL_FOR_STAFF = gql(`
  mutation UpsertCredentialForStaff($id: ID, $input: CredentialForStaffInput!) {
    upsertCredentialForStaff(id: $id, input: $input) {
      id
    }
  }
`);

// Unscoped by tenant on purpose: staff bypass the facility authorization filter,
// so omitting a `tenantId:` term is what makes the picker cross-tenant.
export const STAFF_FACILITY_PICKER_QUERY = gql(`
  query StaffFacilityPicker($search: String, $page: Int, $pageSize: Int, $sort: [SortModel!]) {
    facilities(search: $search, page: $page, pageSize: $pageSize, sort: $sort) {
      items {
        id
        name
        customerFacilityId
        streetAddress1
        city
        state
        zip
        lepc {
          id
          name
        }
        tenant {
          id
          name
        }
      }
      count
    }
  }
`);

export const CREDENTIAL_ID_FOR_PORTAL_USERNAME = gql(`
  query CredentialIdForPortalUsername($portalId: ID!, $username: String!) {
    credentialIdForPortalUsername(portalId: $portalId, username: $username)
  }
`);

export const STAFF_PORTAL_OPTIONS = gql(`
  query StaffCredentialPortalOptions($kind: CredentialKind, $includeId: ID, $includeInactive: Boolean) {
    portalPickerOptions(kind: $kind, includeId: $includeId, includeInactive: $includeInactive) {
      id
      jurisdiction
      description
      portalTech
      url
    }
  }
`);
